import {
	SET_LOCATE_SITE_ARRAY,
	SET_LOCATE_SITE_MARKER_DATA
} from "../actions/types";

const initialState = {
	locate_site_site_array: [],
	locate_site_marker_data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case SET_LOCATE_SITE_ARRAY: {
			return { ...state, locate_site_site_array: action.payload };
		}
		case SET_LOCATE_SITE_MARKER_DATA: {
			return { ...state, locate_site_marker_data: action.payload };
		}
		default: {
			return state;
		}
	}
};



// WEBPACK FOOTER //
// ./src/v3/reducers/locateSitesReducer.js